export const COLORS = {
  main: '#000000',
  light: '#000000',
  dark: '#000000',
  white: '#ffffff',
  mainSecondary: '#404AFF',
  lightSecondary: '#404AFF',
  darkSecondary: '#404AFF',
  // Brand colors from palette
  black: '#000000',
  blue: '#404AFF',
  yellow: '#CCAD12',
  pink: '#FFAEE0',
  orange: '#FF4633',
  lightBlue: '#3ED6FF',
  lightGray: '#E8E8E8'
};
